module.exports = __webpack_public_path__ + "lato-bold-webfont.bded800ed1e2b93c915d.svg";


//////////////////
// WEBPACK FOOTER
// C:/WS/Fusion/FusionDashboard/resources/fonts/lato-bold-webfont.svg
// module id = ../../../../../resources/fonts/lato-bold-webfont.svg
// module chunks = styles